import '../globals';
import { Collapse } from "bootstrap";

/**
 * Initialize accordion elements
 */
(function(PageLoadedQueue) {
    const collapseHide = (trigger) => {
        trigger.ariaExpanded = false;
        trigger.classList.add('collapsed');
    }

    const collapseShow = (trigger) => {
        trigger.ariaExpanded = true;
        trigger.classList.remove('collapsed');
    }

    const initCollapse = (accordionEl) => {
        const trigger = accordionEl.querySelector('[data-plandent-toggle="collapse"]');
        const collapseEl = accordionEl.querySelector('.collapse');

        const toggle = collapseEl.classList.contains('show');

        let collapse = Collapse.getOrCreateInstance(collapseEl, {
            toggle: false
        });

        if (toggle) {
            collapseShow(trigger);
            collapse.show();
        } else {
            collapseHide(trigger);
            collapse.hide();
        }

        trigger.addEventListener('click', () => {
            if (trigger.classList.contains('collapsed')) {
                collapse.show();
                collapseShow(trigger);
            } else {
                collapse.hide();
                collapseHide(trigger);
            }
        },{passive: true});

        collapseEl.addEventListener('hide.bs.collapse', () => {
            collapseHide(trigger);
        }, {passive: true});

        collapseEl.addEventListener('show.bs.collapse', () => {
            collapseShow(trigger);
        }, {passive: true});
    }

    window.PageLoadedQueue.addFunction(function() {
        const accordions = document.querySelectorAll('.accordion-item');
        if (accordions.length) {
            Array.from(accordions).forEach((accordionEl) => {
                initCollapse(accordionEl);
            });
        }

        /**
         * Footer Collapse
         */
        // Open / Close accordions in footer on page load / resize
        const footerThemesCollapses = document.querySelectorAll('#footer-themes .collapse');
        if (footerThemesCollapses.length) {
            Array.from(footerThemesCollapses).forEach((collapseEl) => {
                let options = {show: true};

                if (Viewport.mediaBreakpointDown('MD')) {
                    let options = {hide: true};
                }

                const collapse = Collapse.getOrCreateInstance(collapseEl, options);

                window.addEventListener('resize', () => {
                    if (Viewport.mediaBreakpointDown('MD')) {
                        collapse.hide();
                    }
                    else {
                        collapse.show();
                    }
                }, {passive: true});
            });
        }

        if (Viewport.mediaBreakpointDown('MD')) {
            document.dispatchEvent(new Event('plandent.subcategories.resetHeights'));
            document.dispatchEvent(new Event('plandent.articles.resetHeights'));
        } else {
            document.dispatchEvent(new Event('plandent.subcategories.setHeights'));
            document.dispatchEvent(new Event('plandent.articles.setHeights'));
        }
    });
})(window.PageLoadedQueue);
